"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const state = {};
const mutations = {};
const getters = {};
const actions = {};
const modulo = {
    state,
    actions,
    getters,
    mutations
};
exports.default = modulo;
